import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { css } from '@styled-system/css';
import React from 'react';

import { Alert, Box, Flex, Icon, Text } from '~/components/blocks';

const Guidance = styled(Box)(({ theme }) =>
  css({
    fontSize: theme.fontSizes.s,
    backgroundColor: theme.colors.background.default,
    padding: `${theme.space.m} ${theme.space.l}`,
    margin: `${theme.space.m} 0`,
    borderRadius: theme.radii.default,
    '& ul, li': {
      listStyleType: 'initial',
      listStylePosition: 'inside',
      marginLeft: '16px',
      textIndent: '-16px',
    },
  }),
);

export const CancelUnavailableSendMessageAlert = React.memo(() => {
  const theme = useTheme();

  return (
    <Alert status="error" mt={theme.space.m} withIcon={false}>
      <Flex alignItems="center" mt={theme.space.s}>
        <Icon size="l" icon="info" color="patientRed" />
        <Text ml={theme.space.s} size="s" fontWeight={theme.fontWeights.bold}>
          必ずご確認ください
        </Text>
      </Flex>
      <Text size="s">
        <span style={{ fontWeight: 'bold' }}>
          LINE公式アカウント無料メッセージ配信上限に到達したため、通知機能はご利用になれません。
        </span>
        患者にご連絡の際は電話などをご利用ください
      </Text>
      <Guidance>
        <Text size="s" fontWeight="bold">
          キャンセルする前に
        </Text>
        <ul>
          <li>患者に理由を伝え、他薬局での薬の受け取り方法をご案内してください</li>
        </ul>
      </Guidance>
    </Alert>
  );
});

CancelUnavailableSendMessageAlert.displayName = 'CancelUnavailableSendMessageAlert';
